import { useState, useEffect } from "react";
import { getByLocalization, localize } from "../../common/services/localization";
import { PageContainer } from "../components/layout/page";
import { Table } from "../components/ui/tables";
import { UpdatesHistory } from "../../api/repositories/stats/models/updates";
import { PaginationButtons } from "../components/functional/buttons";
import { toDate, toDateWithTime } from "../../common/utils";
import { UpdatesRepository } from "../../api/repositories/stats/updates";
import { SubscribeGlobalState } from "../../common/hooks/global-state";
import { TableRows } from "../components/ui/models/tables";

export const Updates: React.FC = () => {
    return (
        <PageContainer
            staticBg={true}
            containerClassName="flex flex-col justify-center items-center min-h-[350px]"
            headerImgPath="/v2/images/bg/dragon.png"
            child={<div className="max-w-[1033px]">
                <h2 className="mb-[60px] uppercase">{localize('updates_title')}</h2>
                <UpdatesContainer />
            </div>} />
    );
};

const UpdatesContainer: React.FC = () => {
    const language = SubscribeGlobalState('language')

    const repository = new UpdatesRepository();
    const valuesOnPageCount = 20;

    const [response, setResponse] = useState<ApiPaginationResponse<UpdatesHistory> | undefined>();
    const [page, setGamesPage] = useState(1);

    const handlePageChange = (page: number) => {
        setGamesPage(page);
        getPageValues(page);
    };

    useEffect(() => {
        getPageValues(page)
    }, [])

    function getPageValues(page: number) {
        repository.getHistory(page, valuesOnPageCount)
            .then(v => {
                if (v.hasErrors)
                    return console.log(v.errors);

                setResponse(v);
            });
    }

    return <div>
        {
            <div>
                <Table
                    needSeparate={true}
                    cols={[
                        { headLocalName: "updates_table_name", className: "lg:w-[320px] text-left lg:pl-[43px] lg:py-[8px]" },
                        { headLocalName: "updates_table_type", className: "lg:w-[128px] text-center" },
                        { headLocalName: "updates_table_date", className: "lg:w-[128px] text-center lg:pr-[43px]" },
                    ]}
                    rows={
                        response
                            ? response.data
                                ? response.data.values.map((update) => ({
                                    href: `/updates/${update.url}`,
                                    cols: [
                                        { value: getByLocalization(update.ruName, update.engName), className: 'lg:w-[209px] text-[12px] lg:text-[18px] text-left lg:pl-[43px] lg:py-[16px]' },
                                        { value: localize(update.type), className: 'lg:w-[128px] text-[12px] lg:text-[18px] text-center ' },
                                        { value: toDate(update.createdAt), className: 'lg:w-[107px] text-[12px] lg:text-[18px] text-center lg:pr-[43px]' },
                                    ],
                                }))
                                : getEmptyRows()
                            : getEmptyRows()
                    }
                />
                {
                    response
                        ? response.data.totalCount <= valuesOnPageCount
                            ? null
                            : <PaginationButtons
                                className="mt-[32px]"
                                response={response}
                                currentPage={page}
                                onClick={handlePageChange}
                            />
                        : <></>
                }
            </div>
        }
    </div>
}

function getEmptyRows(): TableRows[] {
    const rows = [];

    for (let index = 0; index < 3; index++) {
        rows.push({
            cols: [
                { value: '', className: 'h-[60px]' },
                { value: '', className: '' },
                { value: '', className: '' },
            ],
        } as TableRows)
    }

    return rows;
}
